mod.modules.define("RevenueSales", "BaseModule", function(fn) {
	"use strict";

	var cache = {
		// DOM
		$actuals: null,
		$estimates: null,
		$overlay: null
	};

	fn.prototype.init = function (params) {
		this.base("init", params);

		cache.$actuals = this.el.find("select.actual-16");
		cache.$estimates = this.el.find("select.estimate-16");
		cache.$overlay = this.el.find("select.overlay-16");
	};

	fn.prototype.loadChart = function () {
		var actuals = cache.$actuals.val();
		var estimates = cache.$estimates.val();

		var loadData = {
			NumberOfActualsAnn: actuals,
			NumberOfEstimatesAnn: estimates,
			NumberOfActualsQtr: (actuals * 4),
			NumberOfEstimatesQtr: (estimates * 4)
		};

		if (cache.$overlay.val() != "defaultText") {
			loadData.Overlay = cache.$overlay.val();
		}

		this.reload(loadData);
	};

	fn.prototype.events = {
		"button[data-action]": {
			"click": function (e, $el) {
				var view = $el.data("action");
				this.el.find("div[data-view]").hide().filter("[data-view=" + view + "]").show();
			}
		},
		"select": {
			"change": function(e, $el) {
				this.loadChart();
			}
		}
	};

});